var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',[_c('div',{class:["btn-item"]},[_c('cube-basic-picker')],1),_c('div',{class:["btn-item"]},[_c('cube-multi-picker')],1),_c('div',{class:["btn-item"]},[_c('cube-subtitle-picker')],1),_c('div',{class:["btn-item"]},[_c('cube-update-data-picker')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }